import { Readable } from "node:stream"
import * as readline from "node:readline/promises"

export function line_reader(input: Readable) {
  const rl = readline.createInterface({ input })
  let closed = false
  let error: Error | null = null

  const close = () => {
    if (closed) return
    closed = true
    rl.close()
    input.destroy()
  }

  const fail = (err: Error) => {
    if (closed) return
    if (!error) error = err
    close()
  }

  input.on('error', fail)
  rl.on('error', fail)

  const iterator: AsyncIterator<string> = rl[Symbol.asyncIterator]()

  const read = async (): Promise<string | null> => {
    if (error) throw error
    if (closed) return null
    const { value, done } = await iterator.next()
    if (error) throw error
    if (done) {
      close()
      return null
    }
    return value as string
  }

  return { read, close, error: () => error, closed: () => closed }
}
